import axios from 'axios'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

const PARTEX_SERVICE_URL = getEnv(Env.PartExServiceUrl)
const partex = axios.create({ baseURL: PARTEX_SERVICE_URL })

export const createValuation = (vrm: string, mileage: number, condition: string) => {
  return partex.post('/valuation/create', { vrm, mileage, condition })
}
